import { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import HeroSection from "../Components/HeroSection";
import AboutusThumbnail from "../Images/Aboutus_Thumbnail.jpg";
import TitleContent from "../Components/TitleContent";
import Simplebigboxcomponent from "../Components/Simplebigboxcomponent";
import BigboxComponent from "../Components/BigboxComponent";
import { aboutdata, portfoliodata } from "../Data/Aboutus";
import { coreteamprofile, advisoryprofile } from "../Data/Profiles";
import global from "../../src/Images/globe.png";
import arrow1 from "../../src/Images/arrow1.png";
import arrow2 from "../../src/Images/arrow2.png";
import { Profilecomponent, Advisors } from "../Components/Profilecomponent";
import VideoComponent from "../Components/VideoComponent";
import BackgroundGradient from "../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../Images/BackgroundGradientSmall.png";
import { currentSite } from "../Config/siteConfig";

export default function Aboutus() {
  // const backgroundImageBig = generateSvgDataUrl("#060606", 70, 70);
  // const backgroundImageSmall = generateSvgDataUrl("#060606", 50, 50);
  // const [backgroundImage, setBackgroundImage] = useState(backgroundImageSmall);
  const [backgroundImage, setBackgroundImage] = useState(``);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    const updateBackgroundImage = () => {
      const screenWidth = window.innerWidth;

      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();
  }, []);

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const rows = [
    coreteamprofile.slice(0, 4), // first row → 4
    coreteamprofile.slice(4, 9), // second row → 5
    coreteamprofile.slice(9, 13), // third row → 4
  ];

  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7 ">
      <div
        className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <Header id={2} />
        <div className="w-full h-[25rem] ">
          <HeroSection
            title1="Crafting Tomorrow's"
            title2="Innovations Today"
            content={`${currentSite === "site1" ? "Qulabs" : "Quantum AI Global"} is a leading deep-tech company building the foundational “picks and shovels” for the quantum era. We develop advanced quantum and AI hardware and software systems from quantum communications and sensing platforms to AI-driven quantum solutions bridging cutting-edge research with real-world deployment across academia, industry, and government`}
            // buttons={
            //   <>
            //     <HoverBorderButton
            //       containerClassName="rounded-full"
            //       as="a"
            //       href="/brochures/QAIG Introduction Brochure.pdf"
            //       download="QAIG Introduction Brochure.pdf"
            //       className="bg-black font-RobotoMedium text-xs md:text-sm text-white flex items-center px-3 py-1"
            //     >
            //       <>
            //         <svg
            //           xmlns="http://www.w3.org/2000/svg"
            //           className="w-4 h-4 mr-2"
            //           fill="none"
            //           viewBox="0 0 24 24"
            //           stroke="currentColor"
            //           strokeWidth="2"
            //         >
            //           <path
            //             strokeLinecap="round"
            //             strokeLinejoin="round"
            //             d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
            //           />
            //         </svg>
            //         <span>QAIG Introduction Brochure</span>
            //       </>
            //     </HoverBorderButton>
            //     <HoverBorderButton
            //       containerClassName="rounded-full"
            //       as="a"
            //       href="/brochures/QAIG Quantum Solutions for Academia.pdf"
            //       download="QAIG Quantum Solutions for Academia.pdf"
            //       className="bg-black font-RobotoMedium text-xs md:text-sm text-white flex items-center px-3 py-1"
            //     >
            //       <>
            //         <svg
            //           xmlns="http://www.w3.org/2000/svg"
            //           className="w-4 h-4 mr-2"
            //           fill="none"
            //           viewBox="0 0 24 24"
            //           stroke="currentColor"
            //           strokeWidth="2"
            //         >
            //           <path
            //             strokeLinecap="round"
            //             strokeLinejoin="round"
            //             d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
            //           />
            //         </svg>
            //         <span>QAIG Quantum Solutions for Academia</span>
            //       </>
            //     </HoverBorderButton>
            //   </>
            // }
          />
        </div>
      </div>
      <div className="w-full width flex flex-col items-center justify-center  md:px-10 2xl:px-20 gap-6 mb-10 relative">
        <div className="w-full h-auto md:h-[33rem] p-3 width grid lg:grid-cols-2 justify-items-center   items-center  ">
          <div className="w-full md:w-[90%] h-full flex flex-col justify-center items-center   p-3">
            <div className="w-full  flex flex-col items-center justify-center gap-1">
              {/* <div className='w-full  text-left text-xs md:text-sm  font-RobotoBold text-white  px-3'>Discover Our Quantum Journey </div> */}
              <div className="w-full text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3 mb-3">
                Discover Our Journey at the Intersection of{" "}
                <span className="wordGradient">Quantum Technology and AI.</span>
              </div>
            </div>
            <div className="w-full text-white text-center md:text-left font-RobotoRegular text-xs md:text-sm px-3">
              At the intersection of quantum technology and artificial
              intelligence, we design and deliver scalable products, solutions,
              and infrastructure that enable organizations to adopt and leverage
              quantum capabilities. Through strong R&D and product innovation,
              we transform complex scientific advancements into practical,
              deployable systems.
            </div>
          </div>
          <img
            src={global}
            className="w-[32.75rem] h-[31.31rem] object-contain"
          ></img>
        </div>
        <div className="w-full width  z-10  2xl:px-20">
          <div className="flex flex-wrap max-w-full md:gap-5 gap-4 items-center justify-center  cursor-pointer px-3">
            {aboutdata.map((item) => (
              <div key={item.id} className="flex-item">
                <Simplebigboxcomponent
                  name={item.name}
                  content={item.content}
                />
              </div>
            ))}
          </div>
        </div>
        <div
          className="absolute -z-2 left-1/2 top-[60%] transform -translate-x-1/2 -translate-y-1/2 inset-0 md:w-[80%] md:h-[12rem]"
          style={{
            background:
              "radial-gradient(circle at center, rgba(70,196,255,0.2), transparent )",
            filter: "blur(70px)",
          }}
        ></div>
      </div>
      {currentSite === "site2" && (
        <div className="w-full width  flex flex-col items-center justify-center my-10 gap-6">
          <TitleContent
            title="Our Journey"
            content="Founded by experts in quantum technologies and AI, Qulabs has grown into a globally recognized deep-tech company with strong IP, patented innovations, and market-ready products serving academia, industry, and government across India, the US, and the UAE."
          />
       
          {currentSite === "site2" && (
            <VideoComponent
              image={AboutusThumbnail}
              video={"https://thequantum.ai/videos/AboutUs.mp4"}
            />
          )}
        </div>
      )}
      <div className="w-full width  flex flex-col items-center justify-center my-10 gap-6 relative ">
        <TitleContent title="Our portfolio of products includes" content="" />

        <div className=" flex flex-col items-center justify-center  md:py-10 z-10 py-7 ">
          <div className="relative w-full max-w-[80rem] py-5 ">
            <div className="flex flex-wrap max-w-full md:gap-5 gap-4 items-center justify-center  cursor-pointer px-3">
              {portfoliodata.map((item) => (
                <div key={item.id} className="flex-item">
                  <BigboxComponent name={item.name} content={item.content} />
                </div>
              ))}
            </div>
            <img
              src={arrow1}
              className="absolute -z-2 left-[32%] -top-[10%]  inset-0 w-[5.31rem] h-[3.25rem] hidden lg:block"
            ></img>
            <img
              src={arrow2}
              className="absolute -z-2 left-[62%]  top-[88%]  inset-0 w-[5.31rem] h-[3.25rem] hidden lg:block"
            ></img>
          </div>
        </div>
        <div
          className="absolute -z-2 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 inset-0 md:w-[80%] md:h-[12rem]"
          style={{
            background:
              "radial-gradient(circle at center, rgba(70,196,255,0.3), transparent )",
            filter: "blur(70px)",
          }}
        ></div>
      </div>

      <div className="w-full width  flex flex-col items-center justify-center my-10 gap-6 relative ">
        <TitleContent
          title="Meet Our Team"
          content="We are passionate about building next generation technology with ease and scale."
        />

        <div className="w-full width flex flex-col items-center justify-center gap-2">
          <TitleContent title="Core Team" content="" />

          <div className="hidden xl:flex flex-col items-center gap-1">
            <div className="grid grid-cols-4 gap-2">
              {coreteamprofile.slice(0, 4).map((item) => (
                <Profilecomponent key={item.id} {...item} />
              ))}
            </div>

            {/* <div className="w-[300px] h-[1px] bg-[#1B99D4] my-1"></div> */}
            <div className="grid grid-cols-5 gap-2">
              {coreteamprofile.slice(4, 9).map((item) => (
                <Profilecomponent key={item.id} {...item} />
              ))}
            </div>
            {/* <div className="w-[300px] h-[1px] bg-[#1B99D4] my-1"></div> */}
            <div className="grid grid-cols-4 gap-2">
              {coreteamprofile.slice(9, 13).map((item) => (
                <Profilecomponent key={item.id} {...item} />
              ))}
            </div>
          </div>

          <div className="xl:hidden flex flex-wrap  items-center justify-center md:px-10  cursor-pointer px-3">
            {coreteamprofile.map((item) => (
              <div key={item.id} className="flex-item">
                <Profilecomponent
                  name={item.name}
                  img={item.img}
                  linkedin={item.linkedin}
                  title={item.title}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="w-full width flex flex-col items-center justify-center gap-2">
          <TitleContent title="Advisory" content="" />

          <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-3 mx-auto justify-center md:px-20 md:py-10 px-3 py-7 cursor-pointer">
            {advisoryprofile.map((item) => (
              <div key={item.id} className="flex-item ">
                <Advisors
                  name={item.name}
                  linkedin={item.linkedin}
                  title={item.title}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer showpage={true} />
    </div>
  );
}
